import { React } from "react"
import { Row, Col } from "react-bootstrap"
import Accordion from "react-bootstrap/Accordion";

import "../../../assets/stlyes/BigPicture/EOYP.scss";

import AccordionUp from "../../../assets/images/AccordionUp.png";
import AccordionDown from "../../../assets/images/AccordionDown.png";
import belowDot from "../../../assets/images/belowDot.png";
import workingDot from "../../../assets/images/workingDot.png";
import expectedDot from "../../../assets/images/expectedDot.png";
import greaterDot from "../../../assets/images/greaterDot.png";

import { EOYP_ProgressBar } from "./";
import { MarkingLevels } from "../../../helper";

const SubjectAccordion = (props) => {
  const { subject, index, openAccordionIndex, setOpenAccordionIndex } = props;
  
  return (
    <div className="subject-accordion">
      <Accordion activeKey={openAccordionIndex === index ? index + 1 : ""} onSelect={() => setOpenAccordionIndex(openAccordionIndex === index ? null : index)}>
        <Accordion.Item eventKey={index + 1}>
          <Accordion.Header>{Object.keys(subject)}<img alt="" src={openAccordionIndex === index ? AccordionUp : AccordionDown} /></Accordion.Header>
          <Accordion.Body>
            <SubjectLevelLabels />
            <EOYP_ProgressBar subject={subject} />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  )
}

const SubjectLevelLabels = () => {
  return (
    <div className="subjectLevelLabels">
      <Row>
        <Col sm={9}></Col>
        <Col sm={3}>
          <div className="labels">
            <span className="subject-labels"><img alt="" src={belowDot} />{MarkingLevels.Extended.BLW}</span>
            <span className="subject-labels"><img alt="" src={workingDot} />{MarkingLevels.Extended.WTS}</span>
            <span className="subject-labels"><img alt="" src={expectedDot} />{MarkingLevels.Extended.EXS}</span>
            <span className="subject-labels"><img alt="" src={greaterDot} />{MarkingLevels.Extended.GDS}</span>
          </div>
        </Col>
      </Row>
    </div >
  )
}

export { SubjectAccordion }
